const numberFormatter = new Intl.NumberFormat("en-US");

export function formatAttendance(num) {
  if (!num && num !== 0) {
    return "";
  }

  return numberFormatter.format(num);
}
